// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"437":"e21eb34f","562":"60203ce6","988":"e21eb34f"}[chunkId] + ".chunk.css";
};